import React, { useState, useEffect } from "react";
import { api } from "../../services/api";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import Swal from 'sweetalert2';
import './index.css';
import { FaBullhorn, FaUserClock, FaSync } from 'react-icons/fa';

function FilaAtendimento() {
    const [listaFila, setListaFila] = useState([]);
    const [lojaAtual] = useState(1);
    const [tvs, setTvs] = useState([]);
    

    const limparIP = (ip) => {
        if (!ip) return "";
        const match = ip.match(/\d/);
        return match ? ip.substring(match.index) : ip;
    };

    function carregarFila() {
        api.get(`/atendimento/fila?cli_loja=${lojaAtual}`)
            .then(retorno => setListaFila(retorno.data))
            .catch(err => console.error("Erro ao carregar fila:", err));
    }

    {/*function carregarTvs() {
        api.get('/buscartv') 
            .then(res => setTvs(res.data))
            .catch(err => console.log("Erro ao buscar TVs:", err));
    }*/}

    async function handleChamar(visita) {
        // Recupera apenas a Mensagem salva no navegador
        const mensagemSalva = localStorage.getItem('ultima_mensagem_chamada') || "";

        const { value: formValues } = await Swal.fire({
            title: `<span style="color: #4A90E2">Chamar ${visita.cli_nome}</span>`,
            icon: 'info',
            html: `
            <div style="text-align: left; font-family: sans-serif;">
                <div>
                    <label for="swal-msg" style="font-weight: bold; font-size: 14px; color: #555; display: block; margin-bottom: 5px;">
                        <i class="fas fa-comment-dots"></i> Mensagem Adicional:
                    </label>
                    <textarea id="swal-msg" class="swal2-textarea" 
                        style="margin: 0; width: 100%; height: 100px; resize: none; border-radius: 5px; border: 1px solid #ccc; padding: 10px;"
                        placeholder="Ex: Comparecer à recepção">${mensagemSalva}</textarea>
                </div>
                <small style="display: block; margin-top: 10px; color: #888;">
                    * Esta mensagem ficará salva para a próxima chamada.
                </small>
            </div>`,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Disparar Chamada',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            preConfirm: () => {
                const mensagem = document.getElementById('swal-msg').value;

                // Salva a mensagem no localStorage para persistência local
                localStorage.setItem('ultima_mensagem_chamada', mensagem);

                return {
                    mensagem: mensagem
                }
            }
        });

        if (formValues) {
            const dadosChamada = {
                cli_loja: visita.cli_loja,
                cli_local: visita.cli_local,
                cli_senha: visita.cli_senha,
                cli_datahora: visita.cli_datahora,
                cli_nome: visita.cli_nome,
                cli_empresa: visita.cli_empresa,
                cli_tipo: visita.cli_tipo,
                texto_especifico: formValues.mensagem
            };

            api.put('/atendimento/fila', dadosChamada)
                .then(() => {
                    Swal.fire({
                        title: 'Chamado!',
                        text: 'Comando enviado com sucesso.',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    carregarFila();
                })
                .catch(() => {
                    Swal.fire('Erro', 'Falha ao processar chamada no banco local', 'error');
                });
        }
    }

    useEffect(() => {
        carregarFila();
        // carregarTvs();
        const interval = setInterval(carregarFila, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <Menu modulo="ARBOR"/>
            <div className="container container-atendimento mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="text-primary"><FaUserClock /> Atendimento Local</h2>
                    <button className="btn btn-outline-secondary" onClick={carregarFila}>
                        <FaSync /> Atualizar
                    </button>
                </div>

                <div className="card shadow-sm border-0 rounded-4 overflow-hidden">
                    <table className="table table-hover mb-0">
                        <thead className="table-dark">
                            <tr>
                                <th>Data/Hora</th>
                                <th>Senha</th>
                                <th>Visitante / Empresa</th>
                                <th>Setor - Pessoa</th>
                                <th>Status</th>
                                
                                <th className="text-center">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaFila.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center p-5 text-muted">Nenhum registro encontrado.</td>
                                </tr>
                            ) : (
                                listaFila.map((visita) => (
                                    <tr key={visita.cli_loja + visita.cli_senha + visita.cli_datahora}>
                                        <td className="align-middle">{visita.cli_datahora}</td>
                                        <td className="align-middle">
                                            <span className="badge bg-primary fs-6">#{visita.cli_senha}</span>
                                        </td>
                                        <td className="align-middle">
                                            <strong>{visita.cli_nome}</strong>
                                            
                                            {/* LINK DO WHATSAPP AO LADO DO NOME SE EXISTIR VALOR */}
                                            
                                            {visita.cli_whatsapp && (
                                                <a 
                                                    href={`https://api.whatsapp.com/send?phone=55${visita.cli_whatsapp.replace(/\D/g, '')}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="ms-2 text-success text-decoration-none"
                                                    title="Chamar no WhatsApp"
                                                    style={{ fontSize: '1.1rem' }}
                                                >
                                                    <i className="fab fa-whatsapp"></i>
                                                </a>
                                            )}
                                            <br />
                                            
                                            <small className="text-muted">{visita.cli_empresa}</small>

                                            {/* INÍCIO DO CAMPO CLI_DESCRICAO DECODIFICADO */}
                                            {visita.cli_descricao && (
                                                <div style={{
                                                    fontSize: '0.85rem',
                                                    color: '#d63384', // Cor destacada para observação
                                                    marginTop: '4px',
                                                    padding: '4px 8px',
                                                    backgroundColor: '#fff0f6',
                                                    borderRadius: '4px',
                                                    display: 'inline-block',
                                                    width: '100%'
                                                }}>
                                                    <i className="fas fa-info-circle me-1"></i>
                                                    {(() => {
                                                        try {
                                                            // Decodifica Base64 tratando caracteres especiais/acentos
                                                            return decodeURIComponent((window.atob(visita.cli_descricao)));
                                                        } catch (e) {
                                                            return "Descrição inválida";
                                                        }
                                                    })()}
                                                </div>
                                            )}
                                            {/* FIM DO CAMPO */}
                                        </td>
                                        <td className="align-middle">
                                            <span className="badge bg-primary fs-6">{visita.cli_setor}</span>
                                        </td>
                                        <td className="align-middle">
                                            {visita.cli_status === 'I' ? (
                                                <span className="badge bg-warning text-dark">Aguardando</span>
                                            ) : visita.cli_status === 'C' || visita.cli_status === 'A' ? ( // Ajustado para aceitar 'A'
                                                <span className="badge bg-info text-dark">Chamado</span>
                                            ) : (
                                                <span className="badge bg-light text-dark">{visita.cli_status}</span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <button className="btn btn-success btn-sm px-3" onClick={() => handleChamar(visita)}>
                                                <FaBullhorn /> Chamar
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default FilaAtendimento;


